const initialState = {
    pathologyPermissionsApproval:{},
    pathologyListsApproval: [],
    pathologyStatusApproval: [],
    changedPathologyStatusApproval : [],
    loadingPathologyApproval: false,
    errorsPathologyApproval: {},
    errorsPathologyApproval:"",
    pathologyIdApproval :'',
    pathologyDetailsApproval :[],
    pathologyViewDetailsApproval :[],
    radiologyPathologyAddressApproval :[],
    errorsBasicApproval:{},
    errorsRemarkApproval:{},
    errorsAlertApproval:{},
    errorsBlackListApproval:{},
    errorsGRIApproval:{},
    errorsRateApproval:{},
}

const  pathologyApprovalReducer = (state = initialState, action) => {
    switch (action.type) {
        case "GET_PATHOLOGYLIST_PENDING_APPROVAL":
        case "ADD_PATHOLOGY_PENDING_APPROVAL":
        case "UPDATE_PATHOLOGY_PENDING_APPROVAL":
        case "UPDATE_PATHOLOGY_STATUS_PENDING_APPROVAL":
        case "DELETE_PATHOLOGY_PENDING_APPROVAL":
        case "GET_PATHOLOGYLISTBYID_PENDING_APPROVAL":
        case "GET_PATHOLOGYVIEWLISTBYID_PENDING_APPROVAL":
        case "UPDATE_PATHOLOGY_OWNER_PENDING_APPROVAL":
        case "UPDATE_PATHOLOGY_LICENSE_PENDING_APPROVAL":
        case "UPDATE_PATHOLOGY_HOSPITAL_PENDING_APPROVAL":
        case "UPDATE_PATHOLOGY_RATE_PENDING_APPROVAL":
        case "UPDATE_PATHOLOGY_REMARK_PENDING_APPROVAL":
            return { ...state, loadingPathologyApproval: true };
        case "SET_MESSAGE_APPROVAL":
            return { ...state,
                errorsPathologyApproval:action.payload 
            };
        case "EDIT_PATHOLOGY_FORM_CLOSED_APPROVAL":
            return { 
                ...state, 
                pathologyIdApproval:"",
                pathologyDetailsApproval :[],
                radiologyPathologyAddressApproval :[],
                errorsBasicApproval:{},
                errorsRemarkApproval:{},
                errorsAlertApproval:{},
                errorsBlackListApproval:{},
                errorsGRIApproval:{},
                errorsRateApproval:{},
                errorsPathologyApproval:{}
            };
        case "EDIT_PATHOLOGY_FORM_FULFILLED_APPROVAL":
            return { 
                ...state, 
                pathologyIdApproval:action.payload,
                errorsPathologyApproval:"",
                errorsPathologyApproval:{}
            };
        case "GET_PATHOLOGYLIST_FULFILLED_APPROVAL":
            return {
                ...state,
                loadingPathologyApproval: false,
                pathologyListsApproval: action.payload,
                pathologyCountApproval: action.count,
                pathologyPermissionsApproval:action.permissions,
                errorsPathologyApproval:{}
            };

        case "ADD_PATHOLOGY_FULFILLED_APPROVAL":
            return {
                ...state,
                loadingPathologyApproval: false,
                pathologyDetailsApproval: action.payload?.data,
                pathologyIdApproval: action.payload?.data?.id,
                radiologyPathologyAddressApproval: action.payload?.radiologyPathologyAddressApproval,
                errorsPathologyApproval: action.payload?.errorsPathologyApproval,
                changedPathologyStatusApproval: action.payload,
                errorsBasicApproval:{},
                otherErrorApproval:{},
                errorsPathologyApproval:{}
            };

        case "UPDATE_PATHOLOGY_FULFILLED_APPROVAL":
            return {
                ...state,
                loadingPathologyApproval: false,
                pathologyDetailsApproval: action.payload?.data,
                pathologyIdApproval: action.payload?.data?.id,
                radiologyPathologyAddressApproval: action.payload?.radiologyPathologyAddressApproval,
                errorsPathologyApproval: action.payload?.errorsPathologyApproval,
                changedPathologyStatusApproval: action.payload,
                errorsBasicApproval:{},
                errorsPathologyApproval:{}
            };
        case "UPDATE_PATHOLOGY_OWNER_FULFILLED_APPROVAL":
            return {
                ...state,
                loadingPathologyApproval: false,
                errorsPathologyApproval: action.payload?.errorsPathologyApproval,
                changedPathologyStatusApproval: action.payload,
                errorsPathologyApproval:{},
            };
        case "UPDATE_PATHOLOGY_LICENSE_FULFILLED_APPROVAL":
            return {
                ...state,
                loadingPathologyApproval: false,
                errorsPathologyApproval: action.payload?.errorsPathologyApproval,
                changedPathologyStatusApproval: action.payload,
                errorsPathologyApproval:{},
            };
        case "UPDATE_PATHOLOGY_HOSPITAL_FULFILLED_APPROVAL":
            return {
                ...state,
                loadingPathologyApproval: false,
                errorsPathologyApproval: action.payload?.errorsPathologyApproval,
                changedPathologyStatusApproval: action.payload,
                errorsPathologyApproval:{},
            };
        case "UPDATE_PATHOLOGY_REMARK_FULFILLED_APPROVAL":
            return {
                ...state,
                loadingPathologyApproval: false,
                errorsPathologyApproval: action.payload?.errorsPathologyApproval,
                changedPathologyStatusApproval: action.payload,
                errorsRemarkApproval:{},
                errorsPathologyApproval:{}
            }; 
            case "UPDATE_PATHOLOGY_ALERT_FULFILLED_APPROVAL":
                return {
                    ...state,
                    loadingPathologyApproval: false,
                    errorsPathologyApproval: action.payload?.errorsPathologyApproval,
                    changedPathologyStatusApproval: action.payload,
                    errorsAlertApproval:{},
                    errorsPathologyApproval:{}
                };
                case "UPDATE_PATHOLOGY_BLACKLIST_FULFILLED_APPROVAL":
                    return {
                        ...state,
                        loadingPathologyApproval: false,
                        errorsPathologyApproval: action.payload?.errorsPathologyApproval,
                        changedPathologyStatusApproval: action.payload,
                        errorsBlackListApproval:{},
                        errorsPathologyApproval:{}
                    };
                    case "UPDATE_PATHOLOGY_GRI_FULFILLED_APPROVAL":
                        return {
                            ...state,
                            loadingPathologyApproval: false,
                            errorsPathologyApproval: action.payload?.errorsPathologyApproval,
                            changedPathologyStatusApproval: action.payload,
                            errorsGRIApproval:{},
                            errorsPathologyApproval:{}
                        };
                    
        case "UPDATE_PATHOLOGY_RATE_FULFILLED_APPROVAL":
            return {
                ...state,
                loadingPathologyApproval: false,
                errorsPathologyApproval: action.payload?.errorsPathologyApproval,
                changedPathologyStatusApproval: action.payload,
                errorsRateApproval:{},
                errorsPathologyApproval:{}
            };

        case "UPDATE_PATHOLOGY_STATUS_FULFILLED_APPROVAL":
            return {
                ...state,
                loadingPathologyApproval: false,
                changedPathologyStatusApproval: action.payload,
                errorsPathologyApproval: action.payload?.errorsPathologyApproval,
                errorsPathologyApproval:{}
            };

        case "GET_PATHOLOGYLISTBYID_FULFILLED_APPROVAL":
            return {
                ...state,
                loadingPathologyApproval: false,
                pathologyDetailsApproval: action.payload,
                pathologyIdApproval: action.payload?.id,
                radiologyPathologyAddressApproval: action.payload?.RadiologyPathologyAddress,
                changedPathologyStatusApproval: action.payload,
                errorsPathologyApproval:{}
            };

        case "GET_PATHOLOGYVIEWLISTBYID_FULFILLED_APPROVAL":
            return {
                ...state,
                loadingPathologyApproval: false,
                pathologyViewDetailsApproval: action.payload,
            };

        case "DELETE_PATHOLOGY_FULFILLED_APPROVAL":
            return {
                ...state,
                loadingPathologyApproval: false,
                errorsPathologyApproval: action.payload?.errorsPathologyApproval,
                errorsPathologyApproval:{}
            };

        case "RESET_DELETE_PATHOLOGYS_STATUS_APPROVAL":
            return {
                ...state,
                loadingPathologyApproval: false,
                changedPathologyStatusApproval: [],
                errorsPathologyApproval:{}
            };

        case "GET_PATHOLOGYLIST_REJECTED_APPROVAL":
        case "UPDATE_PATHOLOGY_STATUS_REJECTED_APPROVAL":
        case "DELETE_PATHOLOGY_REJECTED_APPROVAL":
        case "GET_PATHOLOGYLISTBYID_REJECTED_APPROVAL":
        case "GET_PATHOLOGYVIEWLISTBYID_REJECTED_APPROVAL":
        case "UPDATE_PATHOLOGY_OWNER_REJECTED_APPROVAL":
        case "UPDATE_PATHOLOGY_LICENSE_REJECTED_APPROVAL":
        case "UPDATE_PATHOLOGY_HOSPITAL_REJECTED_APPROVAL":
        case "UPDATE_PATHOLOGY_HOSPITAL_REJECTED_APPROVAL":
        case "UPDATE_PATHOLOGY_HOSPITAL_REJECTED_APPROVAL":
            return {
                ...state,
                loadingPathologyApproval: false,
                errorsPathologyApproval: action.payload
            };

        case "ADD_PATHOLOGY_REJECTED_APPROVAL":
        case "UPDATE_PATHOLOGY_REJECTED_APPROVAL":
            return {
                ...state,
                loadingPathologyApproval: false,
                errorsBasicApproval: action.payload?.data,
                errorsPathologyApproval: action.payload,
            };
        case "UPDATE_PATHOLOGY_REMARK_REJECTED_APPROVAL":
            return {
                ...state,
                loadingPathologyApproval: false,
                errorsRemarkApproval: action.payload,
            };
            
            case "UPDATE_PATHOLOGY_ALERT_REJECTED_APPROVAL":
                return {
                    ...state,
                    loadingPathologyApproval: false,
                    errorsAlertApproval:action.payload,
                };  
                case "UPDATE_PATHOLOGY_BLACKLIST_REJECTED_APPROVAL":
                    return {
                        ...state,
                        loadingPathologyApproval: false,
                        errorsBlackListApproval: action.payload,
                    };    
                    case "UPDATE_PATHOLOGY_GRI_REJECTED_APPROVAL":
                        return {
                            ...state,
                            loadingPathologyApproval: false,
                            errorsGRIApproval: action.payload,
                        };    
        case "UPDATE_PATHOLOGY_RATE_REJECTED_APPROVAL":
            return {
                ...state,
                loadingPathologyApproval: false,
                errorsRateApproval: action.payload,
            };

        case "RESET_PATHOLOGY_STATE_APPROVAL":
            return {
                ...state,
                loadingPathologyApproval: false,
                errorsPathologyApproval: {},
                errorsBasicApproval: {},
                errorsRemarkApproval: {},
                errorsAlertApproval: {},
                errorsBlackListApproval: {},
                errorsGRIApproval: {},
                errorsRateApproval: {},
                changedPathologyStatusApproval: [],
                pathologyIdApproval: '',
                pathologyDetailsApproval: [],
                pathologyViewDetailsApproval: [],
                radiologyPathologyAddressApproval: [],
            };
        default:
            return state;
    }
}

export default pathologyApprovalReducer;